var map = {
	"./Data.xlsx": "a987",
	"./DataSourceSpecificIndicator.xlsx": "8214",
	"./Datasource.xlsx": "35c8",
	"./Factor.xlsx": "4567",
	"./Indicator.xlsx": "9554",
	"./Location.xlsx": "9121",
	"./ValueType.xlsx": "d04c",
	"./npc-pop-data.xlsx": "e277",
	"./null.xlsx": "3922"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d4c";